module.exports = __webpack_public_path__ + "static/media/address-search-unavailable.cec244f9.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/message/address-search-unavailable.svg
 ** module id = 1325
 ** module chunks = 0
 **/